import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/dailyOutMachine/selectPage',
    method: 'GET',
    params: {
      ...params
    }
  })
}

// 导出成本统计
export function download (params) {
  return axios({
    url: '/dailyOutMachine/download',
    method: 'get',
    params: params,
    responseType: 'arraybuffer'
  })
}

// 外部机械审计
export function audit (data) {
  return axios({
    url: '/dailyOutMachine/audit/' + data.id + '/' + data.audit,
    method: 'GET'
  })
}

// 外部机械财务确认总金额
export function isAmount (data) {
  return axios({
    url: '/dailyOutMachine/isAmount/' + data.id + '/' + data.isAmount,
    method: 'GET'
  })
}
